import { Box, Typography } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { globalCssVars } from '@/core/theme/GlobalCssVars'

interface Props {
  onClick: () => void
}

export function SearchBarButton({ onClick }: Props) {
  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.75,
        px: 1.5,
        minWidth: 220,
        alignSelf: 'stretch',
        borderRadius: globalCssVars.radius7,
        border: '1px solid',
        borderColor: 'divider',
        cursor: 'pointer',
        userSelect: 'none',
        transition: 'background 0.15s',
        '&:hover': { bgcolor: 'action.hover' },
      }}
    >
      <SearchIcon sx={{ fontSize: 20, color: 'text.secondary', flexShrink: 0 }} />
      <Typography variant="body2" color="text.secondary" sx={{ fontSize: 14 }}>
        Search
      </Typography>
      <Typography variant="caption" color="text.disabled" sx={{ ml: 0.5, fontSize: 12 }}>
        Ctrl K
      </Typography>
    </Box>
  )
}
